// @flow

// Represents all events being tracked, add here for new events
const TrackedEvents = Object.freeze({
  CardSelected: 'Card Selected',
  ButtonSelected: 'Button Selected',
  ToggleSelected: 'Toggle Selected',
  LinkSelected: 'Link Selected',
  CategoryIconSelected: 'Category Icon Selected',
  PageVisited: 'Page Visited',
  StepValid: 'Step Valid',
  ModalShown: 'Modal Shown',
  ExperimentStarted: 'Experiment Started',
});

// Represents all GTM events being tracked, add here for new events
const GTMTrackedEvents = Object.freeze({
  GTMPageVisited: 'itemVisited',
});

// Used when the same event can occur from the same
// urlpath.
const TrackingLocations = Object.freeze({
  Browse: 'browse feed',
  Search: 'search',
  Pin: 'pin',
  HowitWorksPage: 'how it works page',
});

// Used to enumerate any common tracking values
const TrackedItems = Object.freeze({
  MapToggleToBrowse: 'browse',
  MapToggleToMap: 'map',
  Buyer: 'buyer',
  Seller: 'seller',
  StoreFront: 'storefront',
});

const TrackedListingSteps = Object.freeze({
  Location: 'Select Travel & Location',
});

export {
  TrackedEvents,
  TrackingLocations,
  TrackedItems,
  TrackedListingSteps,
  GTMTrackedEvents,
};
